<script setup lang="ts">
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { OnboardingStep, SharedData } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import EditOnboardingStep from './EditOnboardingStep.vue';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import { usePage } from '@inertiajs/vue3';
    import { computed } from 'vue';
    import type { Table } from '@tanstack/vue-table';

    defineProps<{
        onboardingStep: OnboardingStep;
        table: Table<OnboardingStep>;
    }>();

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const { hasPermission } = usePermissions();
</script>

<template>
    <DataTableActions :data="onboardingStep">
        <EditOnboardingStep
            :onboarding-step="onboardingStep"
            :table="table"
        />

        <Delete
            :route="route('v2.onboarding.destroy', { companyOnboardingStep: onboardingStep.id })"
            :query-key="[QueryKey.ONBOARDING, selectedCompanyId]"
            header="onboarding.delete.title"
        />
    </DataTableActions>
</template>
